import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import style from './alerts-grid-container.module.less';
import { GroupByGrid } from '../../../components/group-by-grid';
import ShipTogetherAddress from '../../../components/order-alerts/ship-together/group-by-grid-columns/ship-together-address';
import ShipTogetherName from '../../../components/order-alerts/ship-together/group-by-grid-columns/ship-together-name';
import { emptyArray } from 'ui-components/default-props/empty';
import * as Actions from '../../../store/alerts/grid/alerts.grid.actions';
import Global from '../../../store/global-selectors';

const GRID_COLUMNS = [ShipTogetherName, ShipTogetherAddress];

const getMappedAlerts = (alerts) => {
  const highestCount = alerts.reduce((accum, item) => {
    return Math.max((item.fulfillmentPlanIds || []).length, accum);
  }, 0);
  return alerts.map((alert) => ({
    ...alert,
    id: alert.alertId,
    allowForDigitCount: highestCount.toString().length,
  }));
};

const buildLinkPath = (parentPath, alert) => {
  return `${parentPath}/${alert.alertId}`;
};

/**
 * Container component for the alerts grid that connects to Redux state
 * and provides alerts-specific configuration to the GroupByGrid component
 * @param {object} props - Component props
 * @param {string} [props.parentPath] - Base path for building alert detail links
 * @returns {React.ReactElement} Configured GroupByGrid component
 */
export const AlertsGridContainer = React.memo(({ parentPath }) => {
  const dispatch = useDispatch();
  const alerts = useSelector(Global.selectAlertsGridAlerts) ?? emptyArray;
  const selectedAlertIds = useSelector(Global.selectAlertsGridgetSelectedAlertIds) ?? emptyArray;

  const mappedAlerts = useMemo(() => getMappedAlerts(alerts), [alerts]);

  const setSelectedIds = useCallback(
    (alertIds) => {
      dispatch(Actions.setSelectedAlertIds(alertIds));
    },
    [dispatch],
  );

  return (
    <GroupByGrid
      buildLinkPath={buildLinkPath}
      columnClassName={style['grid-columns']}
      columns={GRID_COLUMNS}
      items={mappedAlerts}
      parentPath={parentPath}
      rowClassName='active-row'
      selectedIds={selectedAlertIds}
      setSelectedIds={setSelectedIds}
    />
  );
});

AlertsGridContainer.displayName = 'AlertsGridContainer';
